const IconManagement = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 20">
      <g data-name="Grupo 4985">
        <g data-name="Grupo 4984">
          <g data-name="Grupo 4982">
            <path
              data-name="Caminho 12325"
              d="M16.71 5.29 19 3h-8v8l2.3-2.3a7.953 7.953 0 0 1 2.37 10.05 8.484 8.484 0 0 0 1.04-13.46z"
              transform="translate(-4.46 -3)"
            />
          </g>
          <g data-name="Grupo 4983">
            <path
              data-name="Caminho 12326"
              d="M7.46 8.88a7.912 7.912 0 0 1 .88-3.63A8.484 8.484 0 0 0 7.3 18.71L5 21h8v-8l-2.3 2.3a7.981 7.981 0 0 1-3.24-6.42z"
              transform="translate(-4.46 -3)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default IconManagement;
